export const sortIceHockeyBothTeamToScore = (x, y) => {
    return x.id.endsWith("Q20") ? -1 : 1;
};
//# sourceMappingURL=sortIceHockeyBothTeamToScore.js.map